import { Datalayer } from "../omnia";

export class TextureLayer extends Datalayer {

}
